import React, { useState, useEffect } from 'react';
import Userimg from '../Images/icons8-user-50.png';
import { useAccount } from '../assets/js/ContextProviders/AccountContext';
import { retrieveData } from '../apis/dataService';

const MyAccount = () => {
    const { GetEmail } = useAccount();

    // State for account information
    const [AccountInfo, setAccountInfo] = useState({
        userName: "LOGIN/SIGNUP",
        userEmail: "Not Provided",
        userAddress: "Not Provided",
        userPhone: "Not Provided",
        userPassword: "Not Provided",
        memberSince: "Not Provided"
    });

    const [orders, setOrders] = useState([]);
    const [totalOrders, setTotalOrders] = useState(0);
    const [showPassword, setShowPassword] = useState(false);

    const fetchData = async () => {
        const email = GetEmail();
        if (!email) {
            console.error('No email found in local storage.');
            return;
        }

        try {
            const accountInfo = await retrieveData({
                var: email,
                api: '/myaccount'
            });

            if (accountInfo && accountInfo.length > 0) {
                setAccountInfo(accountInfo[0]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchOrders = async () => {
        try {
            const products = await retrieveData({
                var: GetEmail(),
                api: '/orders'
            });
            setOrders(products);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        fetchData();
        fetchOrders();
    }, []);

    useEffect(() => {
        if (orders) {
            setTotalOrders(orders.length);
        }
    }, [orders]);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className='Your-Account'>
            <div className="userProfile">
                <div className="userProfile-dp">
                    <div className="user-dp">
                        <div>
                            <img src={Userimg} alt="User" />
                        </div>
                        <div className='user-dp-name'>
                            <span>{AccountInfo.userName}</span>
                        </div>
                    </div>
                </div>
                <div className='parent-userInfo'>
                    <div className="userInfo">
                        <h3>Contact Number:</h3>
                        <div>{AccountInfo.userPhone}</div>
                        <h3>Shipping Address:</h3>
                        <div>{AccountInfo.userAddress}</div>
                        <h3>Email:</h3>
                        <div>{AccountInfo.userEmail}</div>
                        <h3>Password:</h3>
                        <div id="Password-div">
                            <input
                                type={showPassword ? "text" : "password"}
                                id="password-input"
                                value={AccountInfo.userPassword}
                                readOnly
                            />
                            <div className="show-hidden-password" onClick={togglePasswordVisibility}>
                                <i className={showPassword ? "far fa-eye-slash" : "far fa-eye"} id="toggle-password"></i>
                            </div>
                        </div>
                    </div>
                    <div className="userInfo2">
                        <div className="userInfo2-div">
                            <span className='userInfo-large'>
                                {totalOrders}
                            </span>
                            <i className="fas fa-box-open"></i>
                            <span>
                                Total Orders
                            </span>
                        </div>
                        <div className="userInfo2-div">
                            <span className='userInfo-large'>
                                {AccountInfo.memberSince}
                            </span>
                            <i className="fas fa-child"></i>
                            <span>
                                Member Since
                            </span>
                        </div>
                        <div className="userInfo2-div">
                            <span className='userInfo-large'>
                                Completed
                            </span>
                            <i className="fas fa-shield-alt"></i>
                            <span>
                                Security
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyAccount;
